module.exports = __webpack_public_path__ + "img/chainsaw.772e54a8.png";